import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import WorkflowCompatibility from "../../../components/Workflow/WorkflowCompatibility";

class NL_Translate_init extends PureComponent {
  render() {
    return (
      <div className="row" id="nl_translate_init">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>NL.Translate.init</h2>
              <p>
                NL.Translate.init Initialises the AWS Translate library. This allows you run batch translations into multiple languages.
              </p>
              <p style={{ color: "#D32F2F", fontWeight: "bold" }}>You require a seperate AWS account with appropriate permissions.</p>
              <WorkflowCompatibility front={false} back={true} />
              <h3>Options</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Option</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">accessKeyId</td>
                    <td>
                      AWS accessKeyId created in the AWS console.
                      <br />
                      <i>String</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">apiVersion</td>
                    <td>
                      "2017-07-01"
                      <br />
                      <i>String (optional)</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">cacheEnabled</td>
                    <td>
                      Enables the S3 caching engine
                      <br />
                      <i>true, false default is true</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">cacheAutoSave</td>
                    <td>
                      Cache Auto Save sets after how many new translations entries will the cache file be saved.
                      <br />
                      <i>false, 1-1000 default is 200</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">cacheSave</td>
                    <td>
                      Enables saving the cache back to the S3
                      <br />
                      <i>true, false default is true</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">cacheTTL</td>
                    <td>
                      Cache TTL sets the expiry for unused items in seconds.
                      <br />
                      <i>0-31536000 default is 7776000 (90 days)</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">langInput</td>
                    <td>
                      Lang Input is the input language.
                      <br />
                      <i>"en", "fr", "de", "es" default is "en"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">langOuput</td>
                    <td>
                      Lang Output sets the languages to translate to
                      <br />
                      <i>["de", "es", "fr"] default is ["fr"]</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">lengthLimit</td>
                    <td>
                      Length limit sets the max section string length to be translated.
                      <br />
                      <i>1-4500 default is 4500</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">region</td>
                    <td>
                      "eu-west-2"
                      <br />
                      <i>String (optional)</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">S3Bucket</td>
                    <td>
                      Name of the AWS S3 bucket that contains the cache file.
                      <br />
                      <i>String</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">S3TranslateCacheKey</td>
                    <td>
                      Key or filename in the S3 bucket where the cache file can be found.
                      <br />
                      <i>String</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">secretAccessKey</td>
                    <td>
                      AWS secretAccessKey created in the AWS console.
                      <br />
                      <i>String</i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>NL.Translate.init Example</h2>
              <p>This example initialises the AWS Translate library.</p>
              <div className="darkCode">
                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">options</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">accessKeyId</span>
                  <span className="jsonA">: "</span>
                  <span className="jsonG">AKLMEDKENISJQOUT...</span>
                  <span className="jsonA">",</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">secretAccessKey</span>
                  <span className="jsonA">: "</span>
                  <span className="jsonG">ofmsSgfmnuienSBNemiwo+fknwnofg+sdFSMF...</span>
                  <span className="jsonA">",</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">S3Bucket</span>
                  <span className="jsonA">: "</span>
                  <span className="jsonG">my_bucket</span>
                  <span className="jsonA">",</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">S3TranslateCacheKey</span>
                  <span className="jsonA">: "</span>
                  <span className="jsonG">my_project/cache.json</span>
                  <span className="jsonA">",</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">langInput</span>
                  <span className="jsonA">: "</span>
                  <span className="jsonG">en</span>
                  <span className="jsonA">",</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">langOuput</span>
                  <span className="jsonA">: [</span>
                  <span className="jsonA">"</span>
                  <span className="jsonG">fr</span>
                  <span className="jsonA">", </span>
                  <span className="jsonA">"</span>
                  <span className="jsonG">es</span>
                  <span className="jsonA">", </span>
                  <span className="jsonA">"</span>
                  <span className="jsonG">de</span>
                  <span className="jsonA">"</span>
                  <span className="jsonA">]</span>
                </div>
                <div>
                  <span className="jsonY">&#125;</span>
                  <span className="jsonA">;</span>
                </div>
                <div>
                  <br />
                </div>
                <div>
                  <span className="jsonPink">NL</span>
                  <span className="jsonA">.</span>
                  <span className="nodeCode">Translate</span>
                  <span className="jsonA">.</span>
                  <span className="jsDeclaration">init</span>
                  <span className="jsonY">(</span>
                  <span className="nodeCode">options</span>
                  <span className="jsonA">, </span>
                  <span className="jsonP">function</span>
                  <span className="jsonA">(</span>
                  <span className="jsonPink">err</span>
                  <span className="jsonA">, </span>
                  <span className="jsonPink">data</span>
                  <span className="jsonA">) </span>
                  <span className="jsonA">&#123;</span>
                </div>

                <div className="i1">
                  <span className="jsonA">if (</span>
                  <span className="jsonPink">err</span>
                  <span className="jsonA">) </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsComment">// Failed</span>
                </div>
                <div className="i1">
                  <span className="jsonY">&#125;</span>
                  <span className="jsonA"> else </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsComment">// Success</span>
                </div>
                <div className="i1">
                  <span className="jsonY">&#125;</span>
                </div>

                <div>
                  <span className="jsonA">&#125;</span>
                  <span className="jsonY">)</span>
                  <span className="jsonA">;</span>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default NL_Translate_init;



// WEBPACK FOOTER //
// ./src/components/knowlege/workflow/NL_Translate_init.js